import { t } from '@/i18n';

/**
 * 服务端消息的翻译（韩文第一层，1.0 D11）。
 *
 * 后端高频错误以 `@key|参数1|参数2` 形态返回（共享包 serverText 生成），
 * 这里按当前语言翻译。约定：
 *   · 不以 @ 开头的消息原样返回 —— 存量中文句子不受影响，1.0.1 再逐步翻
 *   · 参数名按各 key 文案的 {p0} {p1}… 顺序对应
 *   · submitCheck.stageNotDone 的两个参数是 section / stage 的代码，
 *     分别用 sheetSection.* / sheetStage.* 翻译 —— 后端不拼节名，
 *     节名的语言跟着界面走
 */
export function translateServerText(raw: string): string {
  if (!raw.startsWith('@')) return raw;
  const [key, ...values] = raw.slice(1).split('|');
  if (!key) return raw;

  const params: Record<string, string> = {};
  if (key === 'submitCheck.stageNotDone') {
    // 参数是代码，先翻成节名/阶段名再进句子
    params.section = values[0] ? t(`sheetSection.${values[0]}`) : '';
    params.stage = values[1] ? t(`sheetStage.${values[1]}`) : '';
  } else {
    values.forEach((v, i) => {
      params[`p${i}`] = v;
    });
  }

  const text = t(key, params);
  return text === key ? raw : text;
}
